<button
  type="button"
  class="pda-button"
  [attr.aria-pressed]="isActive"
  [attr.aria-label]="isActive ? 'Sei connesso a PDA' : 'Connettiti a PDA'"
  [ngClass]="isActive ? 'logged' : ''"
  (click)="connectToPda()"
  [appTooltip]="isActive ? 'Sei connesso a PDA' : 'Connettiti a PDA'" 
  placement="bottom" 
  [appTooltipEnabled]="true">
  <!-- <span class="sr-only">{{ isActive ? 'Sei connesso a PDA' : 'Connettiti a PDA' }}</span> -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    [attr.fill]="!isActive ? '#b1b1b1' : '#41de59'"
    height="24"
    viewBox="0 -1090 960 960"
    width="24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M200-280v-280h80v280h-80Zm240 0v-280h80v280h-80ZM80-120v-80h800v80H80Zm600-160v-280h80v280h-80ZM80-640v-80l400-200 400 200v80H80Zm178-80h444-444Zm0 0h444L480-830 258-720Z"/>
  </svg>
</button>
